import Employee from "./employee/employee.store";

export default {
  modules: { Employee },
};
